export enum ResetPasswordMethods {
  EMAIL = 'EMAIL',
  SMS = 'SMS'
}
